// components/admin/AdminSidebar.tsx
import React from 'react';
import {
  LayoutDashboard,
  FileText,
  Package,
  Settings,
  Star,
  Euro,
} from 'lucide-react';
import Sidebar, { SidebarConfig } from './shared/DashboardSidebar';

interface AdminSidebarProps {
  isCollapsed: boolean;
  onToggle: () => void;
  username: string;
  logoUrl?: string;
  isMobile?: boolean;
}

const AdminSidebar: React.FC<AdminSidebarProps> = ({
  isCollapsed,
  onToggle,
  username,
  logoUrl,
  isMobile = false,
}) => {
  // Vérification si les informations de la boutique sont complètes

  // Construction de la configuration
  const config: SidebarConfig = {
    username,
    logoUrl,
    onActivateModules: () => {
      // Navigation vers les paramètres
      window.location.href = '/admin/parametres';
    },
    sections: [
      {
        title: 'Général',
        items: [
          { 
            icon: LayoutDashboard, 
            label: 'Tableau de bord', 
            path: '/admin/overview' 
          },
          { 
            icon: Settings, 
            label: 'Paramètres', 
            path: '/admin/settings' 
          }
         
        ]
      },
      {
        title: 'Modules',
        items: [
          {
            icon: Package,
            label: 'Produits',
            path: '/admin/products',
          },
          {
            icon: FileText,
            label: 'Commandes',
            path: '/admin/orders',
          },
          {
            icon: Euro,
            label: 'Paiements',
            path: '/admin/payments',
          },
        ]
      }
    ]
  };

  return (
    <Sidebar
      config={config}
      isCollapsed={isCollapsed}
      onToggle={onToggle}
      isMobile={isMobile}
    />
  );
};

export default AdminSidebar;